import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Utils } from '../resources/utils';
import { AuthService } from '../services/authentication.service';
import { Companies } from '../resources/companies';
import { StorageService } from '../services/storage.service';

@Injectable({ providedIn: 'root' })
export class CompanyAccessGuard implements CanActivate {
    constructor(
        private router: Router,
        private authService: AuthService,
        public utils: Utils,
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        return new Promise((resolve) => {
            const userPromise = this.authService.validateUser();
            userPromise.then(() => {
                if (this.authService.getUserSession() && this.authService.getUserSession().clientCompanyId && StorageService.checkStorage().getItem('_companyId')) {
                    const routeUrl = state && state.url ? state.url.split('?')[0] : null;
                    resolve(Companies.companiesAccess(routeUrl, this.authService.getUserSession().clientCompanyId, StorageService.checkStorage().getItem('_companyId')));
                    return;
                }
                this.router.navigate(['/home']);
                resolve(false);
            }).catch(() => {
                this.router.navigate(['/home']);
                resolve(false);
            });
        });
    }
}
